var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_search",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49241163,1.33241947 C5.84431607,1.33241947 4.29648487,1.97238813 3.13482816,3.13482816 C0.730833252,5.53803975 0.730833252,9.44756683 3.13482816,11.8507784 C4.29648487,13.0132184 5.84431607,13.6531871 7.49241163,13.6531871 C9.1405072,13.6531871 10.6883384,13.0132184 11.8499951,11.8507784 C14.2532067,9.44756683 14.2532067,5.53803975 11.8499951,3.13482816 C10.6883384,1.97238813 9.1405072,1.33241947 7.49241163,1.33241947 M15.3216489,16.0211495 C15.140703,16.0211495 14.9699403,15.9506511 14.8414765,15.8229707 L12.2800352,13.2607461 C10.9397826,14.3738373 9.24625477,14.9848233 7.49241163,14.9848233 C5.48712425,14.9848233 3.6056007,14.2069911 2.19171644,12.7931068 C0.77861549,11.3800059 0,9.4969157 0,7.49241163 C0,5.48869088 0.77861549,3.6056007 2.19171644,2.19249976 C3.6056007,0.77861549 5.48712425,0 7.49241163,0 C9.4969157,0 11.3792226,0.77861549 12.7931068,2.19249976 C15.535494,4.93488691 15.7203564,9.34495251 13.2411632,12.3035347 L15.8010379,14.8634094 C15.9295016,14.9910898 16,15.1618525 16,15.3427984 C16,15.5237442 15.9295016,15.694507 15.8010379,15.8229707 C15.6725742,15.9506511 15.5025947,16.0211495 15.3216489,16.0211495",
    id: "Fill-1",
    fill: "#272727"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchDark);
export default __webpack_public_path__ + "static/media/ic_search_dark.479fe3c9.svg";
export { ForwardRef as ReactComponent };